import script from "./FriendList.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendList.vue?vue&type=script&setup=true&lang=js"

import "./FriendList.vue?vue&type=style&index=0&id=a5a1dc60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5a1dc60"]])

export default __exports__